(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4748],{

/***/ 4748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W2": function() { return /* reexport */ EmagazineArticleLayout; },
  "Q8": function() { return /* reexport */ EmagazineArticleMobileLayout; },
  "zG": function() { return /* reexport */ PromotionsArticleLayout; },
  "kC": function() { return /* reexport */ PromotionsArticleMobileLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/index.ts + 88 modules
var components = __webpack_require__(85827);
// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js + 4 modules
var FacebookShareButton = __webpack_require__(8136);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./components/ui/NewGallery/index.tsx
var NewGallery = __webpack_require__(23303);
;// CONCATENATED MODULE: ./features/article/partial/ProductLoop.tsx






var ProductLoop = function(props) {
    var ref, ref1, ref2;
    var p = props.p, t = props.t;
    var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
    var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (p.product_discount && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var isDeposited = p.quantity <= 0 || p.status == shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === shared/* ProductStatus.Deposited */.Pt.Deposited;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20",
                    children: [
                        p.images && p.images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGallery/* default */.Z, {
                                images: p.images
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            alt: p.product_name,
                            src: p.images && p.images[0] ? p.images[0].url : ""
                        }),
                        p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/sale.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "sale"
                                })
                            })
                        }),
                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-z-10",
                            style: {
                                top: "8px",
                                left: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PentagonIcon */.nM, {
                                    text: t("detail.label.soldOut")
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                query: {
                                    id: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1",
                                    children: p.product_code
                                }),
                                p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: t("product:detail.label.contact")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.price - p.price * p.product_discount.discount / 100, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./features/article/partial/RelatedProduct.tsx








var NewProduct = function(param) {
    var products = param.products, t = param.t;
    var LENGTH = products.length;
    var ref = (0,react.useState)([
        0,
        1,
        2
    ]), indexShow = ref[0], setIndexShow = ref[1];
    var ref1 = (0,react.useState)(false), nextDisable = ref1[0], setNextDisable = ref1[1];
    var ref2 = (0,react.useState)(true), previewDisable = ref2[0], setPreviewDisable = ref2[1];
    var next = function() {
        var _Math;
        var max = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(indexShow));
        if (max === LENGTH - 1) {
            return setNextDisable(true);
        }
        if (max < LENGTH - 1) {
            setIndexShow([
                indexShow[1],
                indexShow[2],
                max + 1
            ]);
            setPreviewDisable(false);
        }
    };
    var preview = function() {
        var _Math;
        var min = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(indexShow));
        if (min === 0) {
            return setPreviewDisable(true);
        }
        if (min > 0) {
            setIndexShow([
                min - 1,
                indexShow[0],
                indexShow[1]
            ]);
            setNextDisable(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px] after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px] tw-h-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            src: "/diamond.svg",
                            alt: "star",
                            className: "tw-h-5 tw-w-5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main",
                            children: "C\xe1c sản phẩm li\xean quan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            src: "/diamond.svg",
                            alt: "star",
                            className: "tw-h-5 tw-w-5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-max tw-mx-auto tw-mt-10",
                children: products.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--left-6 md:tw--left-10",
                            children: previewDisable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10",
                                    alt: "left",
                                    src: "/left-light.svg"
                                })
                            }, "pre-disable") : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: preview,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer",
                                    alt: "left",
                                    src: "/left-light.svg"
                                })
                            }, "pre")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-justify-center tw-w-full",
                            children: products.map(function(p, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(indexShow.includes(index) ? "tw-block tw-px-2 tw-duration-400" : "tw-hidden", " tw-w-[248px]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop, {
                                        p: p,
                                        t: t
                                    })
                                }, p.cat_code);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-top-1/2 tw--translate-y-1/2 tw--right-6 md:tw--right-10",
                            children: nextDisable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-opacity-70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10",
                                    alt: "right",
                                    src: "/right-light.svg"
                                })
                            }, "next-disabled") : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: next,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    className: "tw-w-6 tw-h-6 md:tw-h-10 md:tw-w-10 tw-cursor-pointer",
                                    alt: "right",
                                    src: "/right-light.svg"
                                })
                            }, "next")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-full tw-flex tw-gap-4 tw-justify-center",
                    children: products.map(function(p, key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-[248px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop, {
                                p: p,
                                t: t
                            })
                        }, "item-".concat(key));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var RelatedProduct = (/*#__PURE__*/(0,react.memo)(NewProduct));

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./components/ui/Link/index.tsx
var Link = __webpack_require__(43701);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./features/blog/api.ts
var api = __webpack_require__(26892);
;// CONCATENATED MODULE: ./features/article/partial/Breadcrumb.tsx






var Breadcrumb = function(param) {
    var blogId = param.blogId, title = param.title;
    var masterData = (0,profile/* useMasterData */.AE)();
    var ref = (0,react.useState)(), blog = ref[0], setBlog = ref[1];
    var refetch = (0,api/* useFetchBlogQuery */.ZE)(blogId + "", {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            return setBlog(data.data);
        }
    }).refetch;
    (0,react.useEffect)(function() {
        if (blogId) refetch();
    }, [
        blogId,
        refetch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:tw-hidden tw-overflow-x-scroll ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5 tw-w-max",
                    children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            className: "".concat((blog === null || blog === void 0 ? void 0 : blog.slug) === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                            url: {
                                pathname: shared/* PagePath.BlogPage */._.BlogPage,
                                query: {
                                    id: m.slug
                                }
                            },
                            children: m.name
                        }, m.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-font-regular tw-text-secondary-70 tw-text-base tw-flex tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Tin tức \xa0",
                            ">",
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        url: {
                            pathname: shared/* PagePath.BlogPage */._.BlogPage,
                            query: {
                                id: blog === null || blog === void 0 ? void 0 : blog.slug
                            }
                        },
                        className: "!tw-text-secondary-70 ",
                        children: blog === null || blog === void 0 ? void 0 : blog.name
                    }),
                    "\xa0",
                    ">",
                    "\xa0",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-flex-1 tw-line-clamp-1",
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            })
        ]
    });
};
var BreadcrumbMobile = function(param) {
    var blogId = param.blogId, title = param.title;
    var masterData = (0,profile/* useMasterData */.AE)();
    var ref = (0,react.useState)(), blog = ref[0], setBlog = ref[1];
    var refetch = (0,api/* useFetchBlogQuery */.ZE)(blogId + "", {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            return setBlog(data.data);
        }
    }).refetch;
    (0,react.useEffect)(function() {
        if (blogId) refetch();
    }, [
        blogId,
        refetch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:tw-hidden tw-overflow-x-scroll ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-items-center tw-gap-x-8 tw-text-lg md:tw-text-xl tw-uppercase tw-mb-5  tw-w-max",
                    children: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs.map(function(m) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            className: "".concat((blog === null || blog === void 0 ? void 0 : blog.slug) === m.slug ? "tw-font-semibold tw-border-b-[3px] tw-border-primary-main" : "", " !tw-text-secondary-70"),
                            url: {
                                pathname: shared/* PagePath.BlogMobilePage */._.BlogMobilePage,
                                query: {
                                    id: m.slug
                                }
                            },
                            children: m.name
                        }, m.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-font-regular tw-text-secondary-70 tw-text-base tw-flex tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Tin tức \xa0",
                            ">",
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        url: {
                            pathname: shared/* PagePath.BlogMobilePage */._.BlogMobilePage,
                            query: {
                                id: blog === null || blog === void 0 ? void 0 : blog.slug
                            }
                        },
                        className: "!tw-text-secondary-70 ",
                        children: blog === null || blog === void 0 ? void 0 : blog.name
                    }),
                    "\xa0",
                    ">",
                    "\xa0",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-flex-1 tw-line-clamp-1",
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./libs/axios/index.ts
var axios = __webpack_require__(80787);
;// CONCATENATED MODULE: ./features/article/partial/ambassador-registration/api.ts


var signUpAmbassador = function(payload) {
    return axios/* default.post */.ZP.post("/api/v1/user/ambassador/register", payload);
};
var useSignUpAmbassadorQuery = function(options) {
    return (0,react_query_es.useMutation)(function(payload) {
        return signUpAmbassador(payload);
    }, options);
};

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
;// CONCATENATED MODULE: ./features/article/partial/ambassador-registration/AmbassadorRegistrationForm.tsx












var AmbassadorRegistrationForm = function(props) {
    var ref, ref1;
    var article = props.article;
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var masterData = (0,profile/* useMasterData */.AE)();
    var ambassador_info = masterData === null || masterData === void 0 ? void 0 : masterData.ambassador_info;
    var ref2 = (0,react.useState)(false), isShowSuccessMsg = ref2[0], setIsShowSuccessMsg = ref2[1];
    var ref3 = (0,react.useState)(false), isShowForm = ref3[0], setIsShowForm = ref3[1];
    (0,react.useEffect)(function() {
        var getSlugFromUrl = function(url) {
            if (!url) return "";
            var parts = url.split("/").filter(function(el) {
                return !!el;
            });
            return parts[parts.length - 1];
        };
        var slug = getSlugFromUrl(ambassador_info === null || ambassador_info === void 0 ? void 0 : ambassador_info.url);
        setIsShowForm(slug === article.slug);
    }, [
        article === null || article === void 0 ? void 0 : article.slug,
        ambassador_info === null || ambassador_info === void 0 ? void 0 : ambassador_info.url
    ]);
    var ref4 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            phone: "",
            fullname: ""
        },
        resolver: (0,yup_module/* yupResolver */.X)(es/* object */.Ry({
            phone: es/* string */.Z_().required(t("ambassador-register.message.phone-required")),
            fullname: es/* string */.Z_().required(t("ambassador-register.message.fullname-required"))
        }))
    }), control = ref4.control, handleSubmit = ref4.handleSubmit, errors = ref4.formState.errors;
    var ref5 = useSignUpAmbassadorQuery({
        onSuccess: function() {
            setIsShowSuccessMsg(true);
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutate = ref5.mutate, isLoading = ref5.isLoading;
    var onSubmit = handleSubmit(function(data) {
        mutate((0,_object_spread/* default */.Z)({}, data));
    });
    var keyPress = function(e) {
        if (e.keyCode === 13) {
            onSubmit();
        }
    };
    if (!isShowForm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-w-full sm:tw-w-[440px] tw-mx-auto tw-mt-6 tw-px-2 lg:tw-p-4 tw-rounded-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "tw-text-center tw-text-xl tw-font-semibold",
                        children: t("ambassador-register.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                name: "fullname",
                                control: control,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* UserOutlineIcon */.VD, {
                                        className: "tw-text-primary-main"
                                    })
                                }),
                                variant: components/* InputVariant.Outlined */.Jf.Outlined,
                                error: (ref = errors.fullname) === null || ref === void 0 ? void 0 : ref.message,
                                containerClassName: "tw-h-[50px] tw-px-4 tw-rounded-lg",
                                errorMessageClassName: "tw-px-4",
                                placeholder: t("ambassador-register.form.label.fullname"),
                                onKeyDown: keyPress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                name: "phone",
                                control: control,
                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PhoneIcon */.qW, {
                                        className: "tw-text-primary-main"
                                    })
                                }),
                                variant: components/* InputVariant.Outlined */.Jf.Outlined,
                                error: (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message,
                                containerClassName: "tw-h-[50px] tw-px-4 tw-rounded-lg tw-mt-6",
                                errorMessageClassName: "tw-px-4",
                                placeholder: t("ambassador-register.form.label.phone"),
                                onKeyDown: keyPress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    t: t,
                                    i18nKey: "ambassador-register.label.policies",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                            url: {
                                                pathname: shared/* PagePath.PrivacyPolicyPage */._.PrivacyPolicyPage
                                            }
                                        }, "ambassador-register.label.policies"), 
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                loading: isLoading,
                                onClick: onSubmit,
                                className: "tw-mt-4 tw-h-[50px] tw-rounded-lg",
                                children: t("ambassador-register.btn.submit")
                            })
                        ]
                    })
                ]
            }),
            isShowSuccessMsg && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalCustom */.wW, {
                className: "tw-w-[360px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-font-bold tw-text-lg tw-text-center",
                            children: t("ambassador-register.modal.register-success-title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-text-center",
                            children: t("ambassador-register.modal.register-success-description")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-justify-end tw-gap-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                className: "tw-text-primary-main tw-font-bold",
                                onClick: function() {
                                    return setIsShowSuccessMsg(false);
                                },
                                children: "OK"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ambassador_registration_AmbassadorRegistrationForm = (AmbassadorRegistrationForm);

;// CONCATENATED MODULE: ./features/article/layout.tsx











var EmagazineArticleLayout = function(props) {
    var ref;
    var webUrl = "https://anthu.vn";
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var products = props.products, article = props.article, newArticles = props.newArticles, blogs = props.blogs;
    var yoast_head_json = article.yoast_head_json, title = article.title, categories = article.categories, thumbnail_url = article.thumbnail_url, content = article.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title.rendered,
                description: yoast_head_json.description,
                seo: {
                    title: title.rendered,
                    description: yoast_head_json.description,
                    keywords: (ref = article.acf) === null || ref === void 0 ? void 0 : ref.keywords
                },
                image: thumbnail_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb, {
                        title: title.rendered,
                        blogId: categories[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "tw-mt-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-w-full tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article",
                                dangerouslySetInnerHTML: {
                                    __html: content.rendered
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-center tw-flex tw-items-center tw-justify-end tw-mt-5",
                                children: [
                                    "Chia sẻ:\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                        className: "",
                                        url: "".concat(webUrl, "/article/").concat(article.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/facebook-color.png",
                                            className: "tw-w-8 tw-h-8",
                                            alt: "facebook"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ambassador_registration_AmbassadorRegistrationForm, {
                        article: article
                    }),
                    !!products.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-10 tw-hidden lg:tw-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct, {
                            products: products,
                            t: t
                        })
                    })
                ]
            })
        ]
    });
};
var EmagazineArticleMobileLayout = function(props) {
    var webUrl = "https://anthu.vn";
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var products = props.products, article = props.article, newArticles = props.newArticles, blogs = props.blogs;
    var yoast_head_json = article.yoast_head_json, title = article.title, categories = article.categories, thumbnail_url = article.thumbnail_url, content = article.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title.rendered,
                image: thumbnail_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbMobile, {
                        title: title.rendered,
                        blogId: categories[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "tw-mt-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-w-full tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article",
                                dangerouslySetInnerHTML: {
                                    __html: content.rendered
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-center tw-flex tw-items-center tw-justify-end tw-mt-5",
                                children: [
                                    "Chia sẻ:\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                        className: "",
                                        url: "".concat(webUrl, "/article/").concat(article.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/facebook-color.png",
                                            className: "tw-w-8 tw-h-8",
                                            alt: "facebook"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ambassador_registration_AmbassadorRegistrationForm, {
                        article: article
                    }),
                    !!products.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-10 tw-hidden lg:tw-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct, {
                            products: products,
                            t: t
                        })
                    })
                ]
            })
        ]
    });
};
var PromotionsArticleLayout = function(props) {
    var webUrl = "https://anthu.vn";
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var products = props.products, article = props.article, newArticles = props.newArticles, blogs = props.blogs;
    var yoast_head_json = article.yoast_head_json, title = article.title, categories = article.categories, thumbnail_url = article.thumbnail_url, content = article.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title.rendered,
                image: thumbnail_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb, {
                        title: title.rendered,
                        blogId: categories[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "tw-mt-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[400px] xl:tw-h-[420px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: thumbnail_url || "",
                                            alt: title.rendered,
                                            className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-text-center",
                                                    children: (0,dayjs/* humanTimeArticle */.KM)(article.modified, "")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center",
                                                    dangerouslySetInnerHTML: {
                                                        __html: title.rendered
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-text-center tw-flex tw-items-center tw-justify-center tw-mt-2",
                                                    children: [
                                                        "Chia sẻ:\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                                            className: "",
                                                            url: "".concat(webUrl, "/article/").concat(article.slug),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                src: "/facebook-color.png",
                                                                className: "tw-w-8 tw-h-8",
                                                                alt: "facebook"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-mx-auto lg:tw-w-9/12 xl:tw-w-8/12 tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article",
                                dangerouslySetInnerHTML: {
                                    __html: content.rendered
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ambassador_registration_AmbassadorRegistrationForm, {
                        article: article
                    }),
                    !!products.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-10 tw-hidden lg:tw-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct, {
                            products: products,
                            t: t
                        })
                    })
                ]
            }),
            !!newArticles.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-full tw-py-8 lg:tw-py-12 tw-bg-center tw-bg-cover tw-bg-no-repeat tw-mt-10",
                style: {
                    backgroundImage: "url(/bg-live.svg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container tw-mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px] after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main",
                                            children: "Xem th\xeam tin tức mới nhất"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-12 tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-5",
                                children: newArticles.filter(function(n) {
                                    return n.id != article.id;
                                }).slice(0, 3).map(function(a) {
                                    var blog = blogs.find(function(b) {
                                        return b.id === a.categories[0];
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ArticlePage */._.ArticlePage,
                                            query: {
                                                id: a.slug
                                            }
                                        },
                                        className: "tw-w-full tw-rounded-lg tw-overflow-hidden tw-border tw-border-gray-70 hover:tw-border-primary-main !tw-text-secondary-70 tw-duration-500 tw-ease-linear",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-relative tw-w-full tw-pb-[75%]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                    src: a.thumbnail_url || "",
                                                    alt: a.title.rendered,
                                                    className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-right-0",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-px-4 tw-py-3 tw-bg-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-13 tw-uppercase tw-leading-[26px]",
                                                        children: blog === null || blog === void 0 ? void 0 : blog.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "tw-text-base tw-font-semibold tw-line-clamp-2 tw-leading-[26px]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: a.title.rendered
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-leading-6 tw-italic tw-text-sm",
                                                        children: (0,dayjs/* humanTimeArticle */.KM)(a.modified, "")
                                                    })
                                                ]
                                            })
                                        ]
                                    }, a.title.rendered);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var PromotionsArticleMobileLayout = function(props) {
    var webUrl = "https://anthu.vn";
    var t = (0,esm/* useTranslation */.$G)([
        "layout"
    ]).t;
    var products = props.products, article = props.article, newArticles = props.newArticles, blogs = props.blogs;
    var yoast_head_json = article.yoast_head_json, title = article.title, categories = article.categories, thumbnail_url = article.thumbnail_url, content = article.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title.rendered,
                image: thumbnail_url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "tw-hidden",
                children: yoast_head_json.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-py-10 md:tw-border-t tw-border-primary-main tw-text-secondary-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbMobile, {
                        title: title.rendered,
                        blogId: categories[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "tw-mt-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-full tw-relative tw-h-[460px] md:tw-h-[370px] lg:tw-h-[400px] xl:tw-h-[420px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-w-full tw-relative tw-pb-[75%] md:tw-pb-[35%] lg:tw-pb-[26%]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: thumbnail_url,
                                            alt: title.rendered,
                                            className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-w-11/12 md:tw-w-[600px] tw-rounded-t-[28px] tw-px-4 md:tw-px-8 lg:tw-px-10 tw-py-4 lg:tw-py-8 tw-bg-white tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-top-[80%] md:tw-top-[65%] tw-text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-text-center",
                                                    children: (0,dayjs/* humanTimeArticle */.KM)(article.modified, "")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "tw-mt-3 tw-text-lg md:tw-text-xl lg:tw-text-2xl tw-leading-8 tw-font-semibold tw-text-center",
                                                    dangerouslySetInnerHTML: {
                                                        __html: title.rendered
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-text-center tw-flex tw-items-center tw-justify-center tw-mt-2",
                                                    children: [
                                                        "Chia sẻ:\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                                            className: "",
                                                            url: "".concat(webUrl, "/article/").concat(article.slug),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                src: "/facebook-color.png",
                                                                className: "tw-w-8 tw-h-8",
                                                                alt: "facebook"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-base md:tw-text-lg tw-mt-6 md:tw-mt-8 tw-text-gray-52 tw-mx-auto lg:tw-w-9/12 xl:tw-w-8/12 tw-prose tw-prose-sm md:tw-prose-base lg:tw-prose-lg content-article",
                                dangerouslySetInnerHTML: {
                                    __html: content.rendered
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ambassador_registration_AmbassadorRegistrationForm, {
                        article: article
                    }),
                    !!products.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-10 tw-hidden lg:tw-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProduct, {
                            products: products,
                            t: t
                        })
                    })
                ]
            }),
            !!newArticles.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-full tw-py-8 lg:tw-py-12 tw-bg-center tw-bg-cover tw-bg-no-repeat tw-mt-10",
                style: {
                    backgroundImage: "url(/bg-live.svg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container tw-mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-items-center tw-w-full tw-relative after:tw-absolute after:tw-right-0 after:tw-top-1/2 after:tw-h-[1px] after:tw-bg-primary-main/[0.5] before:tw-left-0 before:tw-top-1/2 before:tw-h-[1px] before:tw-bg-primary-main/[0.5] xl:after:tw-w-[300px] xl:before:tw-w-[300px] lg:before:tw-w-[240px] lg:after:tw-w-[240px] md:before:tw-w-[140px] md:after:tw-w-[140px] [425px]:before:tw-w-[30px] before:tw-w-[10px] after:tw-w-[10px] [425px]:after:tw-w-[30px] 2xl:after:tw-w-[400px] 2xl:before:tw-w-[400px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-gap-x-4 tw-px-5 tw-absolute tw-left-1/2 tw--translate-x-1/2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-inline-block tw-text-lg md:tw-text-2xl tw-uppercase tw-font-semibold tw-w-max tw-text-primary-main",
                                            children: "Xem th\xeam tin tức mới nhất"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-12 tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-5",
                                children: newArticles.filter(function(n) {
                                    return n.id != article.id;
                                }).slice(0, 3).map(function(a) {
                                    var blog = blogs.find(function(b) {
                                        return b.id === a.categories[0];
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                        url: {
                                            pathname: shared/* PagePath.ArticleMobilePage */._.ArticleMobilePage,
                                            query: {
                                                id: a.slug
                                            }
                                        },
                                        className: "tw-w-full tw-rounded-lg tw-overflow-hidden tw-border tw-border-gray-70 hover:tw-border-primary-main !tw-text-secondary-70 tw-duration-500 tw-ease-linear",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-relative tw-w-full tw-pb-[75%]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                    src: a.thumbnail_url,
                                                    alt: a.title.rendered,
                                                    className: "!tw-absolute tw-w-full tw-h-full tw-left-0 tw-right-0",
                                                    objectFit: "cover"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-px-4 tw-py-3 tw-bg-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-13 tw-uppercase tw-leading-[26px]",
                                                        children: blog === null || blog === void 0 ? void 0 : blog.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "tw-text-base tw-font-semibold tw-line-clamp-2 tw-leading-[26px]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: a.title.rendered
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-leading-6 tw-italic tw-text-sm",
                                                        children: (0,dayjs/* humanTimeArticle */.KM)(a.modified, "")
                                                    })
                                                ]
                                            })
                                        ]
                                    }, a.title.rendered);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/article/index.ts




/***/ }),

/***/ 26892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ useFetchBlogQuery; },
/* harmony export */   "vQ": function() { return /* binding */ fetchNewsBySlug; }
/* harmony export */ });
/* unused harmony exports fetchNews, fetchBlog, fetchBlogBuySlug, fetchBlogs, useFetchArticleQuery */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7806);
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);




var fetchNews = function(params) {
    return instanceNews.get("/wp-json/wp/v2/posts", {
        params: params
    });
};
var fetchBlog = function(id) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* .instanceNews.get */ .iR.get("/wp-json/wp/v2/categories/".concat(id));
};
var fetchBlogBuySlug = function(slug) {
    return instanceNews.get("/wp-json/wp/v2/categories?slug=".concat(slug));
};
var fetchBlogs = function() {
    return instanceNews.get("/wp-json/wp/v2/categories");
};
var useFetchBlogQuery = function(id, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.Blog */ .S8.Blog,
        id
    ], function(param) {
        var queryKey = param.queryKey;
        var _queryKey = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(queryKey, 2), _$id = _queryKey[1];
        return fetchBlog(_$id);
    }, options);
};
var fetchNewsBySlug = function(id) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* .instanceNews.get */ .iR.get("/wp-json/wp/v2/posts?slug=".concat(id));
};
var useFetchArticleQuery = function(id, options) {
    return useQuery([
        QueryKey.Article,
        id
    ], function(param) {
        var queryKey = param.queryKey;
        var _queryKey = _sliced_to_array(queryKey, 2), _$id = _queryKey[1];
        return fetchNewsBySlug(_$id);
    }, options);
};


/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_FacebookShareButton; }
});

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-share/node_modules/classnames/index.js
var classnames = __webpack_require__(97567);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);


/***/ }),

/***/ 97567:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);